<template>
  <div class="border-radius p-3">
    <popup
        @close="() => {editingId = false;}"
        v-if="editingId"
    >
     <div slot="popupMainContent">
       <pipeline-log-editor
        :entry="getEntryById(editingId)"
        @saved="finishEditing"
       />
     </div>
    </popup>

    <table-widget
        table-classes="newStyle"
        v-if="parsedTaskEntries"
        id="taskEntries"
        :data="parsedTaskEntries"
        :deletable="$store.getters.isSuperAdmin"
        :fields="tableFields"
        :loading="loading"
        :nav-by-clicking-row="true"
        :show-organization="true"
        :title-as-links="false"
        :edit-popup="$store.getters.isSuperAdmin"
        @deleteRow="deleteRow"
        @edit="startEditing"
    />
  </div>
</template>

<script>
import {PipelineSimplifiedExtractSteps} from "@/enum";
import TableWidget from "@/components/widgets/TableWidget.vue";
import Popup from "@/components/Popup.vue";
import PipelineLogEditor from "@/components/pipeline/PipelineLogEditor.vue";
import vmLogEntry from "@/components/pipeline/vmLogEntry";
export default {
  name: "PipelineStateViewer",
  components: {TableWidget, Popup, PipelineLogEditor},
  props: {
    taskEntries: {type: Array, required: true},
  },
  data() {
    return {
      PipelineSimplifiedExtractSteps,
      editingId: null,
      showDeletePrompt: false,
      markAsAborting: false,
      loading: false,
      tableFields: [
        {
          name: 'STARTED AT',
          id: 'startedAt',
          type: 'string',
        },
        {
          name: 'TASK',
          id: 'task',
          type: 'html',
        },
        {
          name: 'FILE',
          id: 'file',
          type: 'html',
        },
        {
          name: 'TIME',
          id: 'totalTime',
          type: 'html',
        },
        {
          name: 'STATUS',
          id: 'pipelineStatus',
          type: 'tag',
        },
        {
          name: 'STARTED BY',
          id: 'startedBy',
          type: 'userId',
        },
        {
          name: 'ABORTED BY',
          id: 'abortedBy',
          type: 'userId',
        },
        /*{
          name: 'ERRORS',
          id: 'errors',
          type: 'string',
        },*/
        {
          name: 'VM COST',
          id: 'price',
          type: 'string',
        },
        {
          name: 'STATS',
          id: 'stats',
          type: 'html',
        },
      ]
    }
  },
  computed: {
    getEntryById() {
      return (id) => {
        return this.taskEntries.find((entry) => entry.id === id);
      }
    },
    parsedTaskEntries() {
      if(this.taskEntries && this.taskEntries.length) {
        let obj = {};
        this.taskEntries.map((entry) => {
          const logEntry = new vmLogEntry(entry);
          if(!logEntry.isValid()) {
            obj[entry.id] = {
              id: entry.id, // needed
              startedAt: Date.now(),
              task: 'FAULTY LOG ENTRY',
              files: []
            };
            return;
          }
          const config = logEntry.getConfig();
          const {
            startedBy = '-',
            abortedBy = '-'
          } = config;
          const {name, color} = logEntry.getPipelineState();
          const price = logEntry.getPrice();
          const vmTime = logEntry.getVmTime();
          const totalTime = logEntry.getTotalTime();
          const {task} = entry;
          obj[entry.id] = {
            ...entry,
            startedAt: logEntry.getCreatedAtString(),
            task: this.$t('pipeline.' + task) + '<br /><span class="lighter">Last step:<br />' + this.$t(logEntry.getLatestStep()) + '</span>',
            stats: this.get3DNumbers(entry),
            id: entry.id, // needed for deletion
            file: logEntry.getFiles().join('<br>'),
            startedBy,
            abortedBy,
            totalTime: 'Total: ' + totalTime + '<br>VM:' + (vmTime ? vmTime : 'n/a'),
            price: price ? price : 'n/a',
            name: this.$t(name), // pipeline status name
            color: color // pipeline status color
          }
        })
        return obj;
      }
      return []
    }
  },
  beforeMount() {
    if(this.$store.getters.isSuperAdmin) {
      this.tableFields.push({
        name: 'EDIT',
        id: 'editPopup',
        type: 'editPopup',
      });
    }
  },
  methods: {
    get3DNumbers(entry) {
      const {vertices, groups, geometries} = entry;
      return 'Groups: ' + this.getStringOrDash(groups) + '<br>Parts: ' + this.getStringOrDash(geometries) + '<br>Vertices: ' + this.getStringOrDash(vertices);
    },
    getStringOrDash(value) {
      return value ? value : '-';
    },
    startEditing(entryId) {
      this.editingId = entryId;
    },
    finishEditing() {
      this.editingId = null;
      this.$emit('reload')
    },
    deleteRow(id) {
      this.$store.dispatch('clientDeleteVMLog', {
        args: [id]
      }).then(() => {
        this.$emit('reload');
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.pipeline-state-viewer {
  background-color: var(--vform-editor-ui-quinary-color);
}
.bg-darker {
  background-color: var(--vform-editor-ui-quinary-color);
}
</style>